import {Component, Inject, Input, OnInit, OnChanges} from '@angular/core';
import { UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import {
  CustomValidator,
  defaultFieldConfig
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf, NgFor } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  SensisEmailComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/sensis-email/sensis-email.component';
import {
  SensisMobileComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/sensis-mobile/sensis-mobile.component';
import {
  AbnSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/abn-search/abn-search.component';

@Component({
    selector: 'app-accountant-details',
    templateUrl: 'accountant-details.component.html',
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatCheckboxModule, MatCheckboxModule, NgIf, MatFormFieldModule,
      MatFormFieldModule, ValidationPartialComponent, MatInputModule, MatInputModule, SensisEmailComponent, SensisMobileComponent,
    AbnSearchComponent]
})
export class AccountantDetailsComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;

  public selectedAbnRecord: any;
  public accountantConfirmation = false;

  constructor(public dialog: MatDialog) {
  }

  ngOnInit() {
    // this.removeValidators();
  }

  setAbnResults(data) {
    // console.log(data);
    // display results in a modal for the user to select
    this.openAbnDialog(data);

  }

  ngOnChanges(changes) {
    if (changes['formGroup']['firstChange'] && changes['formGroup']['currentValue']['value']['companyHasAccountant']) {
      console.log('[hasAccountant]', changes['formGroup']['currentValue']['value']['companyHasAccountant']);
      this.toggleAccountantConfirmation({checked: changes['formGroup']['currentValue']['value']['companyHasAccountant']});
    }
  }

  openAbnDialog(data): void {
    const dialogRef = this.dialog.open(AbnDataDialogComponent, {
      width: '750px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.selectedAbnRecord = result;
      console.log(this.selectedAbnRecord);
    });
  }

  // searchAbnAgain() {
  //   this.selectedAbnRecord = null;
  // }

  toggleAccountantConfirmation(data) {
    // console.log('[toggleAccountantConfirmation]', data);
    this.accountantConfirmation = data.checked;
    if (data.checked) {
      // console.log('[AccountantDetailsComponent]', '[addValidators]');
      this.formGroup.get('companyAccountantAbn').setValidators([Validators.required]);
      this.formGroup.get('companyAccountantContactName').setValidators([Validators.required, CustomValidator.nameValidator(defaultFieldConfig.fullName)]);
      this.formGroup.get('companyAccountantPhone').setValidators([Validators.required]);
      this.formGroup.get('companyAccountantEmail').setValidators([Validators.required, Validators.email]);
    } else {
      // console.log('toggleAccountantConfirmation:', 'validators cleared');
      this.removeValidators();
    }
  }

  removeValidators() {
    // console.log('[AccountantDetailsComponent]', '[removeValidators]');
    this.formGroup.get('companyAccountantAbn').setValidators([]);
    this.formGroup.get('companyAccountantContactName').setValidators([]);
    this.formGroup.get('companyAccountantPhone').setValidators([]);
    this.formGroup.get('companyAccountantEmail').setValidators([]);

    this.formGroup.get('companyAccountantContactName').patchValue('');
    this.formGroup.get('companyAccountantAbn').patchValue('');
    this.formGroup.get('companyAccountantPhone').patchValue('');
    this.formGroup.get('companyAccountantEmail').patchValue('');
    this.formGroup.get('companyAccountantAbnResult').patchValue('');
    this.selectedAbnRecord = null;
  }
}


@Component({
    selector: 'app-abn-data-dialog',
    template: `<h2 mat-dialog-title>Select an ABN record</h2>
  <mat-dialog-content>
    <mat-list *ngFor="let business of data">
      <mat-list-item>
        <div class="col-sm-6">
          {{business['match-name']._text}}
        </div>
        <div class="col-sm-4">
          {{business['australian-business-number']._text}}
        </div>
        <div class="col-sm-2">
          <button mat-raised-button color="'primary'" type="button" class="fmc-button-primary" [mat-dialog-close]="business">Select</button>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
    </mat-list>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">Close</button>
  </mat-dialog-actions>
  `,
    standalone: true,
    imports: [MatDialogModule, MatDialogModule, NgFor, MatListModule, MatButtonModule, MatButtonModule, MatDividerModule]
})
export class AbnDataDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  }
}
